import { useContext } from 'react';
import { PlateSelectionContext } from './PlateSelectionProvider'; 
import { GlobalStateContext } from './PlateScene';

function getWell(state,args){

  
  let exp = state.experiments[args.experimentId];
  let { well } = args;

  let { gridId, row, col } = well;

  let grid = exp.grids[gridId];
  let data = grid[row][col];
  return data;


}


export default function PlateSelectionItemMenu(){

  const { set, state, experimentId } = useContext(GlobalStateContext);
  const selected = useContext(PlateSelectionContext);

  let { wells = [] } = selected;

  let bySubstance = [];
  
  wells.forEach(well => {
    let { gridId, row, col } = well;
    let data = getWell(state,{experimentId,well})
    data.filter(x => x).forEach((subData) => {

      let { substance } = subData;
      bySubstance[substance] = [
      ...(bySubstance[substance]||[]),
      subData
    ]
    })
  })


  let exp = state.experiments[experimentId]
  let { variableMap } = exp;



  return (
    <div class="outline full-height">
      <div>Menu</div>

      <button onClick={() => {
        set({
          type:"clearWells",
          wells,
          experimentId
        })

      }}>Clear Well</button>

      {bySubstance.map((sub,substanceId) => {
        if( !sub ){ return null }

        let subData = variableMap[substanceId];
        let background = subData.color;
        let name = subData.substance;


        let multiSubsSelected = sub.length > 1;

        let valueDiv;
        if( multiSubsSelected ){
          valueDiv = null;
        }else{

          let value = sub[0].value;
          let units = sub[0].units;
          valueDiv = <div class="sg-row" style={{marginRight:5}}><input 
            class="input-no-button"
            type="number"
            onChange={e => {
              let value = Number(e.target.value)
              set({
                type:"setWellsValue",
                experimentId,
                wells,
                value,
                substanceId,
              })

            }}

          style={{
            width:20, fontSize:8}} value={value}/> {units}</div>
        }

                let circle = 7;

        return (
          <div class="sg-row v-center small-margin">
            <div style={{width:circle,height:circle,background, marginRight:4}}/>
            <div>{name}</div>
            <div class="flex-expand"/>
            {valueDiv}
            <button onClick={() => { 
              set({
                type:"clearWellsSubstances",
                wells,
                experimentId,
                substanceId,
              })
            }}>X</button>
          </div>
        )



      })}
    </div>
  )

}

